import React, { useState } from "react";
import {
  Box,
  VStack,
  HStack,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  useDisclosure,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerBody,
  DrawerCloseButton,
  DrawerHeader,
  Image,
  Text,
  Divider,
  Icon,
  useColorMode,
  Badge,
  Wrap,
  WrapItem,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  useBreakpointValue,
  Link,
  IconButton,
  SlideFade,
} from "@chakra-ui/react";
import {
  EmailIcon,
  PhoneIcon,
  CalendarIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronUpIcon,
} from "@chakra-ui/icons";
import {
  FaMapMarkerAlt,
  FaTwitter,
  FaLinkedin,
  FaGithub,
  FaFilePdf,
  FaFileCode,
  FaBehance,
} from "react-icons/fa";
import { FaSquareXTwitter } from "react-icons/fa6";

/** @jsxImportSource @emotion/react */
import { css, keyframes } from "@emotion/react";
import { SiUpwork } from "react-icons/si";
import n8nColor from "../../images/n8n-color.png";

const gradientHoverStyle = css`
  transition: all 0.3s ease-in-out;
  &:hover {
    background: linear-gradient(45deg, #ff6ec4, #7873f5);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`;

const glowingBorder = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

const freebiesButtonProps = {
  width: "100%",
  bg: "green.100",
  color: "green.900",
  rounded: "full",
  fontWeight: "semibold",
  letterSpacing: "wide",
  boxShadow: "md",
  _hover: {
    bg: "green.200",
    transform: "translateY(-1px)",
    boxShadow: "lg",
  },
  _active: {
    transform: "translateY(0)",
    boxShadow: "md",
  },
};

export const Sidebar = () => {
  const isMobile = useBreakpointValue({ base: true, md: false });
  const { colorMode } = useColorMode();
  const freebies = [
    {
      name: "Curated Crypto & Stock Market News Feed to Your App (CoinDesk, CoinTelegraph, Google News & X)",
      files: [
        {
          label: "JSON file",
          href: "/Freebies/Crypto_Stocks_News_Watcher.json",
          icon: FaFileCode,
        },
        {
          label: "Instructions manual",
          href: "/Freebies/instructions.pdf",
          icon: FaFilePdf,
        },
      ],
    },
  ];

  const [activeFreebie, setActiveFreebie] = useState(null);
  const [isFreebiesMenuOpen, setFreebiesMenuOpen] = useState(false);
  const {
    isOpen: isFreebiesDrawerOpen,
    onOpen: onFreebiesDrawerOpen,
    onClose: onFreebiesDrawerClose,
  } = useDisclosure();

  const truncate = (str, max = 40) =>
    str.length > max ? `${str.slice(0, max)}…` : str;

  const truncatedActiveName = activeFreebie
    ? truncate(activeFreebie.name, 12)
    : "";

  const resetFreebies = () => setActiveFreebie(null);
  const handleMenuClose = () => {
    setFreebiesMenuOpen(false);
    resetFreebies();
  };
  const handleMenuToggle = () => {
    if (isFreebiesMenuOpen) {
      handleMenuClose();
      return;
    }
    setFreebiesMenuOpen(true);
    resetFreebies();
  };
  const handleDrawerClose = () => {
    onFreebiesDrawerClose();
    resetFreebies();
  };

  return (
    <Box
      p={4}
      height={{ base: "auto", md: "calc(100vh - 32px)" }}
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="space-between"
      minHeight={{ base: "100%", md: "calc(100vh - 32px)" }}
    >
      <VStack spacing={4} align="center" width="full" flex="1">
        <Box
          position="relative"
          width="120px"
          height="120px"
          borderRadius="md"
          bg={colorMode === "dark" ? "gray.700" : "gray.300"}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Image
            src={require("../../images/Avatar.jpeg")}
            alt="Mohammad Abubakar"
            borderRadius="full"
            boxSize="100px"
            objectFit="cover"
          />
        </Box>
        <Text fontSize={{ sm: "md", base: "lg" }} fontWeight="bold">
          Mohammad Abubakar
        </Text>
        <Wrap spacing={2} justify="center">
          <WrapItem>
            <Badge variant="outline">Developer | Designer</Badge>
          </WrapItem>
        </Wrap>
        {isMobile ? (
          <Accordion allowToggle width="full">
            <AccordionItem>
              <AccordionButton>
                <Box flex="1" textAlign="left">
                  <Text fontSize="sm" fontWeight="bold">
                    More Info
                  </Text>
                </Box>
                <AccordionIcon />
              </AccordionButton>
              <AccordionPanel pb={4}>
                <VStack spacing={3} align="start" width="full">
                  <HStack spacing={3} align="center">
                    <Box
                      width="20px"
                      height="20px"
                      borderRadius="full"
                      bg={colorMode === "dark" ? "gray.700" : "white"}
                      p={6}
                      boxShadow="lg"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Icon as={EmailIcon} />
                    </Box>
                    <Box>
                      <Text fontSize="sm" fontWeight="bold">
                        EMAIL
                      </Text>
                      <Text fontSize="xs">moabubakar230@gmail.com</Text>
                    </Box>
                  </HStack>

                  <HStack spacing={3} align="center">
                    <Box
                      width="20px"
                      height="20px"
                      borderRadius="full"
                      bg={colorMode === "dark" ? "gray.700" : "white"}
                      p={6}
                      boxShadow="lg"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Icon as={CalendarIcon} />
                    </Box>
                    <Box>
                      <Text fontSize="sm" fontWeight="bold">
                        BIRTHDAY
                      </Text>
                      <Text fontSize="xs">Nov 14, 2002</Text>
                    </Box>
                  </HStack>
                  <HStack spacing={3} align="center">
                    <Box
                      width="20px"
                      height="20px"
                      borderRadius="full"
                      bg={colorMode === "dark" ? "gray.700" : "white"}
                      p={6}
                      boxShadow="lg"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Icon as={FaMapMarkerAlt} />
                    </Box>
                    <Box>
                      <Text fontSize="sm" fontWeight="bold">
                        LOCATION
                      </Text>
                      <Text fontSize="xs">Lahore, Pakistan</Text>
                    </Box>
                  </HStack>
                </VStack>
                <Divider my={"6"} />
                <HStack spacing={4} mt={4} justifyContent={"center"}>
                  <IconButton
                    as={Link}
                    href="https://www.linkedin.com/in/mohammad-abubakar-099aa122a/"
                    aria-label="LinkedIn"
                    icon={<FaLinkedin />}
                    size="lg"
                    isExternal
                  />
                  <IconButton
                    as={Link}
                    href="https://www.upwork.com/freelancers/~01dae55f269b1bfec4"
                    aria-label="Upwork"
                    icon={<SiUpwork />}
                    size="lg"
                    isExternal
                  />
                  <IconButton
                    as={Link}
                    href="https://x.com/m7abr_"
                    aria-label="X"
                    icon={<FaSquareXTwitter />}
                    size="lg"
                    isExternal
                  />
                  <IconButton
                    as={Link}
                    href="https://github.com/Mohammad7Abubakar"
                    aria-label="GitHub"
                    icon={<FaGithub />}
                    size="lg"
                    isExternal
                  />
                  <IconButton
                    as={Link}
                    href="https://n8n.io/creators/m7abr/"
                    aria-label="n8n creator"
                    icon={
                      <Image
                        src={n8nColor}
                        boxSize="20px"
                        objectFit="contain"
                        alt="n8n"
                      />
                    }
                    size="lg"
                    isExternal
                  />
                  <IconButton
                    as={Link}
                    href="https://www.behance.net/m7abr"
                    aria-label="Behance"
                    icon={<FaBehance />}
                    size="lg"
                    isExternal
                  />
                </HStack>
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
        ) : (
          <>
            <Divider />
            <VStack spacing={3} align="start" width="full">
              <HStack spacing={3} align="center">
                <Box
                  width="20px"
                  height="20px"
                  borderRadius="full"
                  bg={colorMode === "dark" ? "gray.700" : "white"}
                  p={6}
                  boxShadow="lg"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Icon as={EmailIcon} />
                </Box>
                <Box>
                  <Text fontSize="sm" fontWeight="bold">
                    EMAIL
                  </Text>
                  <Text fontSize="xs">moabubakar230@gmail.com</Text>
                </Box>
              </HStack>

              <HStack spacing={3} align="center">
                <Box
                  width="20px"
                  height="20px"
                  borderRadius="full"
                  bg={colorMode === "dark" ? "gray.700" : "white"}
                  p={6}
                  boxShadow="lg"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Icon as={CalendarIcon} />
                </Box>
                <Box>
                  <Text fontSize="sm" fontWeight="bold">
                    BIRTHDAY
                  </Text>
                  <Text fontSize="xs">Nov 14, 2002</Text>
                </Box>
              </HStack>
              <HStack spacing={3} align="center">
                <Box
                  width="20px"
                  height="20px"
                  borderRadius="full"
                  bg={colorMode === "dark" ? "gray.700" : "white"}
                  p={6}
                  boxShadow="lg"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Icon as={FaMapMarkerAlt} />
                </Box>
                <Box>
                  <Text fontSize="sm" fontWeight="bold">
                    LOCATION
                  </Text>
                  <Text fontSize="xs">Lahore, Pakistan</Text>
                </Box>
              </HStack>
              <Divider />
              <Wrap spacing={3} mt={4} justify="center" w="full">
                <WrapItem>
                  <IconButton
                    as={Link}
                    href="https://www.linkedin.com/in/mohammad-abubakar-099aa122a/"
                    aria-label="LinkedIn"
                    icon={<FaLinkedin />}
                    size="lg"
                    isExternal
                  />
                </WrapItem>
                <WrapItem>
                  <IconButton
                    as={Link}
                    href="https://www.upwork.com/freelancers/~01dae55f269b1bfec4"
                    aria-label="Upwork"
                    icon={<SiUpwork />}
                    size="lg"
                    isExternal
                  />
                </WrapItem>
                <WrapItem>
                  <IconButton
                    as={Link}
                    href="https://x.com/m7abr_"
                    aria-label="X"
                    icon={<FaSquareXTwitter />}
                    size="lg"
                    isExternal
                  />
                </WrapItem>
                <WrapItem>
                  <IconButton
                    as={Link}
                    href="https://github.com/Mohammad7Abubakar"
                    aria-label="GitHub"
                    icon={<FaGithub />}
                    size="lg"
                    isExternal
                  />
                </WrapItem>
                <WrapItem>
                  <IconButton
                    as={Link}
                    href="https://n8n.io/creators/m7abr/"
                    aria-label="n8n creator"
                    icon={
                      <Image
                        src={n8nColor}
                        boxSize="20px"
                        objectFit="contain"
                        alt="n8n"
                      />
                    }
                    size="lg"
                    isExternal
                  />
                </WrapItem>
                <WrapItem>
                  <IconButton
                    as={Link}
                    href="https://www.behance.net/moabubakar1"
                    aria-label="Behance"
                    icon={<FaBehance />}
                    size="lg"
                    isExternal
                  />
                </WrapItem>
              </Wrap>
            </VStack>
          </>
        )}
      </VStack>
      {/* Freebies CTA */}
      <Box width="full" mt={{ base: 6, md: 4 }} mb={{ base: 0, md: 4 }}>
        {isMobile ? (
          <>
            <Box
              borderRadius="full"
              p="2px"
              bgGradient="linear(to-r, green.300, teal.300, green.400)"
              backgroundSize="200% 200%"
              animation={`${glowingBorder} 4s linear infinite`}
            >
              <Button
                {...freebiesButtonProps}
                onClick={() => {
                  resetFreebies();
                  onFreebiesDrawerOpen();
                }}
              >
                Freebies
              </Button>
            </Box>

            <Drawer
              placement="bottom"
              size="xs"
              isOpen={isFreebiesDrawerOpen}
              onClose={handleDrawerClose}
            >
              <DrawerOverlay />
              <DrawerContent borderTopRadius="2xl">
                <DrawerCloseButton />
                <DrawerHeader borderBottomWidth="1px" pt={6}>
                  <HStack
                    justify="space-between"
                    align="center"
                    transition="all 0.2s ease"
                  >
                    <HStack spacing={2} fontSize="sm" align="center">
                      <Text
                        cursor="pointer"
                        color="gray.500"
                        onClick={resetFreebies}
                      >
                        Freebies
                      </Text>
                      {activeFreebie && (
                        <>
                          <ChevronRightIcon boxSize={3} color="gray.400" />
                          <Text fontWeight="semibold" maxW="170px" isTruncated>
                            {truncatedActiveName}
                          </Text>
                        </>
                      )}
                    </HStack>
                    {activeFreebie && (
                      <Button
                        size="xs"
                        variant="ghost"
                        onClick={resetFreebies}
                        leftIcon={<ChevronLeftIcon />}
                      >
                        Back
                      </Button>
                    )}
                  </HStack>
                </DrawerHeader>
                <DrawerBody>
                  {!activeFreebie && (
                    <SlideFade in={!activeFreebie} offsetY="10px">
                      {freebies.map((pack) => (
                        <Button
                          key={pack.name}
                          variant="ghost"
                          justifyContent="space-between"
                          rightIcon={<ChevronRightIcon />}
                          width="full"
                          py={6}
                          onClick={() => setActiveFreebie(pack)}
                        >
                          <Text
                            as="span"
                            textAlign="left"
                            isTruncated
                            maxW="240px"
                          >
                            {truncate(pack.name, 24)}
                          </Text>
                        </Button>
                      ))}
                    </SlideFade>
                  )}

                  {activeFreebie && (
                    <SlideFade in={!!activeFreebie} offsetY="10px">
                      {activeFreebie.files.map((file) => (
                        <Button
                          key={`${activeFreebie.name}-${file.label}`}
                          as={Link}
                          href={file.href}
                          download
                          width="full"
                          justifyContent="flex-start"
                          variant="outline"
                          mb={3}
                          leftIcon={<Icon as={file.icon} boxSize={6} color="green.400" />}
                          onClick={handleDrawerClose}
                        >
                          {file.label}
                        </Button>
                      ))}
                    </SlideFade>
                  )}
                </DrawerBody>
              </DrawerContent>
            </Drawer>
          </>
        ) : (
          <Menu
            isOpen={isFreebiesMenuOpen}
            onClose={handleMenuClose}
            placement="top"
            closeOnSelect={false}
          >
            <Box
              borderRadius="full"
              p="2px"
              bgGradient="linear(to-r, green.300, teal.300, green.400)"
              backgroundSize="200% 200%"
              animation={`${glowingBorder} 4s linear infinite`}
            >
              <MenuButton
                as={Button}
                {...freebiesButtonProps}
                rightIcon={
                  <ChevronUpIcon
                    transition="transform 0.2s"
                    transform={
                      isFreebiesMenuOpen ? "rotate(180deg)" : "rotate(0deg)"
                    }
                  />
                }
                onClick={handleMenuToggle}
              >
                Freebies
              </MenuButton>
            </Box>

            <MenuList p={2} mb={1}>
              <HStack
                justify="space-between"
                align="center"
                px={1}
                py={1}
                transition="all 0.2s ease"
              >
                <HStack spacing={2} fontSize="xs" align="center">
                  <Text
                    cursor="pointer"
                    color="gray.500"
                    onClick={resetFreebies}
                  >
                    Freebies
                  </Text>
                  {activeFreebie && (
                    <>
                      <ChevronRightIcon boxSize={3} color="gray.400" />
                      <Text fontWeight="semibold" maxW="170px" isTruncated>
                        {truncatedActiveName}
                      </Text>
                    </>
                  )}
                </HStack>
                {activeFreebie && (
                  <Button
                    size="xs"
                    variant="ghost"
                    onClick={resetFreebies}
                    leftIcon={<ChevronLeftIcon />}
                  >
                    Back
                  </Button>
                )}
              </HStack>
              <Divider my={2} />
              {!activeFreebie &&
                freebies.map((pack) => (
                  <MenuItem
                    key={pack.name}
                    onClick={() => setActiveFreebie(pack)}
                    icon={<ChevronRightIcon />}
                  >
                    <Text as="span" isTruncated maxW="220px">
                      {truncate(pack.name, 24)}
                    </Text>
                  </MenuItem>
                ))}

              {activeFreebie &&
                activeFreebie.files.map((file) => (
                  <MenuItem
                    key={`${activeFreebie.name}-${file.label}`}
                    as={Link}
                    href={file.href}
                    download
                    onClick={handleMenuClose}
                    icon={<Icon as={file.icon} boxSize={5} color="green.400" />}
                  >
                    {file.label}
                  </MenuItem>
                ))}
            </MenuList>
          </Menu>
        )}
      </Box>
    </Box>
  );
};

export default Sidebar;
